import React, { useMemo, useContext } from 'react'
import { useSelector } from 'react-redux'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { getByTitle, getById } from '@apps/utils/contentful'
import { Icon, Image, Typography } from '@telus/koodo-ui-kit'

const KIT_SUCCESS_COLOR = '#1c7b2b'
const KIT_DANGER_COLOR = '#c9370b'
const LEGACY_SUCCESS_COLOR = '#00853e'
const LEGACY_DANGER_COLOR = '#c9370b'
const COMPATIBILITY_LABEL_TOKENS = {
  fontName: 'StagSans',
  fontSize: 16,
  fontWeight: 600,
  letterSpacing: 0,
  lineHeight: '24px'
}

const PhoneCompatibility = ({ feature, compatible, useKitIcon = false }) => {
  const { pageContent } = useSelector((state) => state.common.content)

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language
  } = useContext(ApplicationContext)

  const haveSimPageContent = useKitIcon
    ? {}
    : getById(pageContent, `haveSimPage`)?.[language] || {}
  const { images } = haveSimPageContent || []
  
  const content = useMemo(() => {
    if (!images) return {}
    return {
      successIcon: getByTitle(images, 'success-icon')?.url,
      failIcon: getByTitle(images, 'fail-icon')?.url
    }
  }, [images])

  const getCompatibilityIcon = (isCompatible) => {
    return isCompatible ? content?.successIcon : content?.failIcon
  }

  const getCompatibilityColor = (isCompatible) => {
    return isCompatible ? 'text-green-success' : 'text-alert'
  }

  if (useKitIcon) {
    const compatibilityColor = compatible ? KIT_SUCCESS_COLOR : KIT_DANGER_COLOR
    return (
      <div className="flex items-center gap-3">
        <Icon
          icon={compatible ? 'Check' : 'Close'}
          variant={{ color: compatible ? 'success' : 'danger', size: 'small' }}
        />
        <Typography
          variant={{ size: 16, bold: true, color: compatibilityColor }}
          tokens={{
            ...COMPATIBILITY_LABEL_TOKENS,
            color: compatibilityColor
          }}
        >
          {feature}
        </Typography>
      </div>
    )
  }

  const legacyCompatibilityColor = compatible ? LEGACY_SUCCESS_COLOR : LEGACY_DANGER_COLOR

  return (
    <p
      className={classNames(getCompatibilityColor(compatible), 'mb-2')}
    >
      <Image
        alt="eSim compatibility icon"
        src={getCompatibilityIcon(compatible)}
        className="inline-block mr-4"
      />
      <Typography
        variant={{ size: 16, bold: true, color: legacyCompatibilityColor }}
        tokens={{
          ...COMPATIBILITY_LABEL_TOKENS,
          color: legacyCompatibilityColor
        }}
      >
        {feature}
      </Typography>
    </p>
  )
}

PhoneCompatibility.propTypes = {
  feature: PropTypes.string.isRequired,
  compatible: PropTypes.bool.isRequired,
  useKitIcon: PropTypes.bool
}

export default PhoneCompatibility
